import React, { Component } from 'react';
import { Step, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router';

class UserFormNavigation extends React.Component {

    getCurrentPath() {
        if (this.props.history.location.pathname.indexOf('/systemadmin/user/create') !== -1) {
            return '/systemadmin/user/create';
        }

        if (this.props.history.location.pathname.indexOf('/systemadmin/user/update') !== -1) {
            return '/systemadmin/user/update';
        }
    }

    getCurrentQueryString() {
        return this.props.history.location.search;
    }

    render() {

        return (
            <Step.Group vertical fluid>
                <Step link
                    active={this.props.history.location.pathname === this.getCurrentPath()}
                    onClick={this.props.clickBasicInformation}
                >
                    <Step.Content>
                        <Step.Title>Basic Information</Step.Title>
                        <Step.Description>Basic Information</Step.Description>
                    </Step.Content>
                </Step>
                <Step link disabled={this.props.clickLoginInformation ? false : true}
                    active={this.props.history.location.pathname === this.getCurrentPath() + '/loginInformation'}
                    onClick={this.props.clickLoginInformation}
                >
                    <Step.Content>
                        <Step.Title>Login Information</Step.Title>
                        <Step.Description>Login Information</Step.Description>
                    </Step.Content>
                </Step>

                <Step link disabled={this.props.clickBankDetail ? false : true}
                    active={this.props.history.location.pathname === this.getCurrentPath() + '/bankDetails'}
                    onClick={this.props.clickBankDetail}>
                    <Step.Content>
                        <Step.Title>Bank Details</Step.Title>
                        <Step.Description>Bank Details</Step.Description>
                    </Step.Content>
                </Step>

                {this.props.showStudentForm &&
                    <Step link disabled={this.props.clickFormStudent ? false : true}
                        active={this.props.history.location.pathname === this.getCurrentPath() + '/student'}
                        onClick={this.props.clickFormStudent}>
                        <Step.Content>
                            <Step.Title>Student Information</Step.Title>
                            <Step.Description>Student Information</Step.Description>
                        </Step.Content>
                    </Step>
                }

                <Step link disabled={this.props.clickCompanies ? false : true}
                    active={this.props.history.location.pathname === this.getCurrentPath() + '/companies'}
                    onClick={this.props.clickCompanies}>
                    <Step.Content>
                        <Step.Title>Companies</Step.Title>
                        <Step.Description>Companies</Step.Description>
                    </Step.Content>
                </Step>

                <Step link disabled={this.props.clickPanelClinics ? false : true}
                    active={this.props.history.location.pathname === this.getCurrentPath() + '/panelClinics'}
                    onClick={this.props.clickPanelClinics}>
                    <Step.Content>
                        <Step.Title>Panel Clinics</Step.Title>
                        <Step.Description>Panel Clinics</Step.Description>
                    </Step.Content>
                </Step>

                <Step link disabled={this.props.clickUserAudit ? false : true}
                    active={this.props.history.location.pathname === this.getCurrentPath() + '/audit'}
                    onClick={this.props.clickUserAudit}>
                    <Step.Content>
                        <Step.Title>Audit</Step.Title>
                        <Step.Description>Audit</Step.Description>
                    </Step.Content>
                </Step>
            </Step.Group>
        );

    }
}

UserFormNavigation.defaultProps = {
    clickBasicInformation: () => { },
    clickLoginInformation: () => { },
    clickBankDetail: () => { },
    clickProposedBankDetail: () => { },
    clickCompanies: () => { },
    clickFormStudent: () => { },
    clickUserAudit:()=>{},
    showStudentForm: true
}

export default withRouter(UserFormNavigation);